import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const licenseDefinition: ResourceDefinition = {
  title: 'Licenses',
  nameSingular: 'License',
  namePlural: 'Licenses',
  className: 'License',
  mainIdentifier: 'name',
  slug: 'taxonomies/licenses',
  path: 'licenses',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (license) => ({
        type: ActionType.Link,
        link: {
          path: `${licenseDefinition.path}/${license.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (license) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: license,
          definition: licenseDefinition
        }
      })
    }
  ]
}
